<template>
  <a-row>
    <a-col span="24">
      <a-spin :spinning="loading">
        <a-breadcrumb>
          <a-breadcrumb-item v-if="breadcrumb.all">
            <a @click="() => openStatics({})">{{breadcrumb.all.name}}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-if="breadcrumb.company.id">
            <a @click="() => openStatics({companyId: breadcrumb.company.id})">{{breadcrumb.company.name}}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-if="breadcrumb.jwDept.id">
            <a @click="() => openStatics({companyId: breadcrumb.company.id, jwDeptId: breadcrumb.jwDept.id})">{{breadcrumb.jwDept.name}}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-if="breadcrumb.jwMajor.id">
            <a @click="() => openStatics({companyId: breadcrumb.company.id, jwDeptId: breadcrumb.jwDept.id, jwMajorId: breadcrumb.jwMajor.id})">{{breadcrumb.jwMajor.name}}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-if="breadcrumb.jwClazz.id">
            <a @click="() => openStatics({companyId: breadcrumb.company.id, jwDeptId: breadcrumb.jwDept.id, jwMajorId: breadcrumb.jwMajor.id, jwClazzId: breadcrumb.jwClazz.id})">{{breadcrumb.jwClazz.name}}</a>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <a-row>
          <a-col>
            <a-form layout="inline">
              <a-form-item label="教材">
                <a-select v-model="textbookId" style="width: 300px" allowClear placeholder="全部教材">
                  <a-select-option v-for="textbook in textbookList" :value="idString(textbook.id)" :key="idString(textbook.id)">
                    {{textbook.name}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="学期">
                <a-select
                  v-model="semesters"
                  mode="multiple"
                  placeholder="请选择学期"
                  style="min-width: 280px"
                  :maxTagCount="2">
                  <a-select-option v-for="item in semesterList" :key="item.semester" :value="item.semester">
                    {{ semesterLabel(item) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="handleSearch">
                  查询
                </a-button>
                <CommonPermissions :p="$permissions.TEXTBOOK_CXJW_STAT.DOWNLOAD">
                  <a-button style="margin-left: 8px;" type="primary" @click="exportData">
                    导出
                  </a-button>
                </CommonPermissions>
                <CommonPermissions :p="$permissions.TEXTBOOK_CXJW_STAT.DOWNLOAD">
                  <a-button v-if="breadcrumb.jwDept.id" style="margin-left: 8px;" type="primary" @click="exportStudentData">
                    按学生导出
                  </a-button>
                </CommonPermissions>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <a-row style="margin-top: 16px;">
          <a-col :span="24">
            <a-card title="使用趋势统计" :bordered="false">
              <a-radio-group slot="extra" v-model="periodType" @change="loadChart">
                <a-radio-button value="MONTH">按月</a-radio-button>
                <a-radio-button value="WEEK">按周</a-radio-button>
              </a-radio-group>
              <div ref="chartRef" style="width: 100%; height: 400px;"></div>
            </a-card>
          </a-col>
        </a-row>
        <a-table row-key="id" style="margin-top: 16px;" :columns="columns" :data-source="schoolStaticList" :pagination="false">
          <a slot="name" slot-scope="text, record" @click="() => openSubStatics(record)">{{ text }}</a>
          <span slot="costTime" slot-scope="text, record">{{ formatStatItem(record.costTime) }}</span>
          <span slot="usedWeekCount" slot-scope="text, record">{{ formatStatItem(record.usedWeekCount) }}</span>
          <span slot="exerciseCount" slot-scope="text, record">{{ formatStatItem(record.exerciseCount) }}</span>
          <span slot="exerciseScore" slot-scope="text, record">{{ formatStatItem(record.exerciseScore) }}</span>
        </a-table>
      </a-spin>
    </a-col>
    <StaticDetail ref="staticDetail"/>
  </a-row>
</template>
<script>
const columns = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '名称',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '兑换册数',
    dataIndex: 'redeemCount',
    key: 'redeemCount',
  },
  {
    title: '每册平均使用周数',
    scopedSlots: { customRender: 'usedWeekCount' },
  },
  {
    title: '每册平均使用时长(含练习)',
    scopedSlots: { customRender: 'costTime' },
  },
  {
    title: '每册平均练习题次',
    scopedSlots: { customRender: 'exerciseCount' },
  },
  {
    title: '每册平均练习正确率',
    scopedSlots: { customRender: 'exerciseScore' },
  },
];

function formatStatItem(item) {
  if (!item) return '-'
  const text = `${item.formatValue || ''}${item.unitLabel || ''}`
  return text || '-'
}

import StaticDetail from './components/StaticDetail.vue'
import TextbookStatV2Api from '@/api/src/statistics/api/TextbookStatV2Api'
import CommonPermissions from '@/components/CommonPermissions'
import { exportFile } from 'table-xlsx';
import echarts from 'echarts';

const textbookStatV2Api = new TextbookStatV2Api()

export default {
  name: "TextbookSchoolStatic",
  components: {
    StaticDetail,
    CommonPermissions
  },
  data() {
    return {
      breadcrumb: {
        all: {
          id: undefined,
          name: '集团'
        },
        company: {},
        jwDept: {},
        jwMajor: {},
        jwClazz: {}
      },
      semesterList: [],
      semesters: [],
      periodType: 'WEEK',
      schoolStaticList: [],
      loading: false,
      columns,
      textbookList: [],
      textbookId: undefined,
      chart: null,
    };
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize)
    const query = this.$route.query || {}
    if (query.textbookId != null && query.textbookId !== '') {
      this.textbookId = this.idString(query.textbookId)
    }
    if (query.semesters) {
      this.semesters = String(query.semesters).split(',').filter(Boolean)
    }
    await this.getSemesterList()
    await this.loadTextbookOptions()
    if (query.companyId) {
      const companyId = Number(query.companyId)
      await this.openSubStatics({
        id: Number.isNaN(companyId) ? query.companyId : companyId,
        name: query.companyName,
      })
    } else {
      await this.getDate()
    }
  },
  methods: {
    formatStatItem,
    idString(id) {
      if (id == null || id === '') return undefined
      return String(id)
    },
    semesterLabel(item) {
      if (!item) return ''
      return item.anyDistributable === false ? `${item.semester}（已截止）` : item.semester
    },
    async getSemesterList() {
      const resp = await textbookStatV2Api.getStatV2SemesterDict()
      this.semesterList = Array.isArray(resp) ? resp : []
      if (!this.semesters.length && this.semesterList.length) {
        this.semesters = [this.semesterList[0].semester]
      }
    },
    buildQueryBody(extra) {
      const body = Object.assign({
        semesters: this.semesters,
      }, extra || {})
      if (this.breadcrumb.company.id) body.companyId = this.breadcrumb.company.id
      if (this.breadcrumb.jwDept.id) body.jwDeptId = this.breadcrumb.jwDept.id
      if (this.breadcrumb.jwMajor.id) body.jwMajorId = this.breadcrumb.jwMajor.id
      if (this.breadcrumb.jwClazz.id) body.jwClazzId = this.breadcrumb.jwClazz.id
      if (this.textbookId) body.textbookId = this.idString(this.textbookId)
      return body
    },
    ensureSemesters() {
      if (!this.semesters || !this.semesters.length) {
        this.$message.warning('请选择学期')
        return false
      }
      return true
    },
    async loadTextbookOptions() {
      if (!this.semesters || !this.semesters.length) {
        this.textbookList = []
        return
      }
      const body = { semesters: this.semesters }
      if (this.$route.query.companyId) {
        const companyId = Number(this.$route.query.companyId)
        body.companyId = Number.isNaN(companyId) ? this.$route.query.companyId : companyId
      }
      const resp = await textbookStatV2Api.getStatV2GroupByTextbook(body)
      const list = Array.isArray(resp) ? resp : []
      if (this.textbookId && !list.some((item) => this.idString(item.id) === this.textbookId)) {
        list.unshift({
          id: this.textbookId,
          name: this.$route.query.textbookName || this.textbookId,
        })
      }
      this.textbookList = list
    },
    async handleSearch() {
      await this.loadTextbookOptions()
      await this.getDate()
    },
    async getDate() {
      if (!this.ensureSemesters()) return
      this.loading = true
      try {
        const params = this.buildQueryBody()
        this.schoolStaticList = await textbookStatV2Api.getStatV2GroupByCompanyDeptMajor(params) || []
        const chartData = await textbookStatV2Api.getStatV2PeriodUsageStatistics(
          this.buildQueryBody({ periodType: this.periodType })
        )
        this.initChart(Array.isArray(chartData) ? chartData : [])
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '获取院校统计失败')
        this.schoolStaticList = []
      } finally {
        this.loading = false
      }
    },
    async loadChart() {
      if (!this.ensureSemesters()) return
      this.loading = true
      try {
        const chartData = await textbookStatV2Api.getStatV2PeriodUsageStatistics(
          this.buildQueryBody({ periodType: this.periodType })
        )
        this.initChart(Array.isArray(chartData) ? chartData : [])
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '获取使用趋势失败')
      } finally {
        this.loading = false
      }
    },
    initChart(data) {
      if (!this.$refs.chartRef) return

      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chartRef)
      }

      const usageName = this.periodType === 'WEEK' ? '当周使用数量' : '当月使用数量'
      const labels = data.map(item => item.label)
      const distributedQuantity = data.map(item => Number(item.distributedQuantity) || 0)
      const usageQuantity = data.map(item => Number(item.usageQuantity) || 0)
      const viewTime = data.map(item => Number(item.viewTime) || 0)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          showTitle: false,
          right: 100,
          feature: {
            dataView: { show: true, readOnly: true },
          }
        },
        legend: {
          data: ['累计发放数量', usageName, '时长(分钟)']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: labels,
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            minInterval: 1,
          },
          {
            type: 'value',
            name: '时长(分钟)',
          }
        ],
        series: [
          {
            name: '累计发放数量',
            type: 'bar',
            data: distributedQuantity,
            barGap: '-100%',
            z: 1,
            itemStyle: {
              color: '#d6e4ff'
            }
          },
          {
            name: usageName,
            type: 'bar',
            data: usageQuantity,
            barGap: '-100%',
            z: 2,
            itemStyle: {
              color: '#5470c6'
            }
          },
          {
            name: '时长(分钟)',
            type: 'line',
            yAxisIndex: 1,
            data: viewTime,
            smooth: true,
            z: 3,
            itemStyle: {
              color: '#ee6666'
            }
          }
        ]
      }

      this.chart.setOption(option, true)
    },
    exportData() {
      exportFile({
        columns: [
          { title: '名称', dataIndex: 'name' },
          { title: '兑换册数', dataIndex: 'redeemCount' },
          { title: '每册平均使用周数', render: function(text, record) {
            return formatStatItem(record.usedWeekCount)
          } },
          { title: '每册平均使用时长(含练习)', render: function(text, record) {
            return formatStatItem(record.costTime)
          } },
          { title: '每册平均练习题次', render: function(text, record) {
            return formatStatItem(record.exerciseCount)
          } },
          { title: '每册平均练习正确率', render: function(text, record) {
            return formatStatItem(record.exerciseScore)
          } },
        ],
        dataSource: this.schoolStaticList,
        fileName: `数据导出.xlsx`
      })
    },
    async exportStudentData() {
      if (!this.ensureSemesters()) return
      this.loading = true
      try {
        const resp = await textbookStatV2Api.getStatV2GroupByStudent(this.buildQueryBody())
        exportFile({
          columns: [
            { title: '姓名', dataIndex: 'realname' },
            { title: '学号', dataIndex: 'code' },
            { title: '分院', dataIndex: 'jwDeptName' },
            { title: '专业', dataIndex: 'jwMajorName' },
            { title: '班级', dataIndex: 'jwClazzName' },
            { title: '兑换册数', dataIndex: 'redeemCount' },
            { title: '使用时长(含练习)', render: function(text, record) {
              return formatStatItem(record.costTime)
            } },
            { title: '使用周数', render: function(text, record) {
              return formatStatItem(record.usedWeekCount)
            } },
            { title: '练习题次', render: function(text, record) {
              return formatStatItem(record.exerciseCount)
            } },
            { title: '练习正确率', render: function(text, record) {
              return formatStatItem(record.exerciseScore)
            } },
          ],
          dataSource: resp || [],
          fileName: `数据导出.xlsx`
        })
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '按学生导出失败')
      } finally {
        this.loading = false
      }
    },
    async openStatics({companyId, jwDeptId, jwMajorId, jwClazzId}) {
      if(!companyId) {
        this.breadcrumb.company = {}
        this.breadcrumb.jwDept = {}
        this.breadcrumb.jwMajor = {}
        this.breadcrumb.jwClazz = {}
      }else if(!jwDeptId) {
        this.breadcrumb.jwDept = {}
        this.breadcrumb.jwMajor = {}
        this.breadcrumb.jwClazz = {}
      }else if(!jwMajorId) {
        this.breadcrumb.jwMajor = {}
        this.breadcrumb.jwClazz = {}
      }else if(!jwClazzId) {
        this.breadcrumb.jwClazz = {}
      }
      await this.getDate()
    },
    async openSubStatics(record) {
      if(!this.breadcrumb.company.id) {
        this.breadcrumb.company = record
      }else if(!this.breadcrumb.jwDept.id) {
        this.breadcrumb.jwDept = record
      }else if(!this.breadcrumb.jwMajor.id) {
        this.breadcrumb.jwMajor = record
      }else if(!this.breadcrumb.jwClazz.id) {
        this.breadcrumb.jwClazz = record
      }
      await this.getDate()
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ant-list-item {
  display: block;
}
.ant-list-item-meta-title {
  font-weight: bold;
}

</style>
